import { Reveal, SectionHead } from "./shared";
import { IMAGES } from "../data/content";

const SCOPES = ["Installation", "Construction", "Engineering", "Execution", "Operation & Maintenance"];

export const Substation = () => (
    <section data-testid="substation-section" className="relative bg-white py-16 lg:py-32">
        <div className="vec-container">
            <SectionHead
                index="SEC 04"
                eyebrow="Substation Infrastructure"
                title="Engineered for Power. Built for Performance."
            />

            <div className="mt-10 lg:mt-12 grid grid-cols-12 gap-y-8 lg:gap-x-12">
                <div className="col-span-12 lg:col-span-8">
                    <Reveal>
                        <figure className="group tech-frame relative overflow-hidden border border-vec-border aspect-[16/9]">
                            <img
                                src={IMAGES.substationLarge}
                                alt="Power transformer and busbar infrastructure inside a high-voltage substation"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                            <figcaption className="absolute bottom-3 left-3 bg-white/90 backdrop-blur px-3 py-1.5 font-mono-tech text-[9px] uppercase tracking-[0.2em] text-vec-charcoal/70">
                                Fig. 03 — Substation Electrical Infrastructure
                            </figcaption>
                        </figure>
                    </Reveal>
                </div>
                <div className="col-span-12 lg:col-span-4 flex flex-col justify-between gap-8">
                    <Reveal delay={0.1}>
                        <p className="text-base sm:text-lg leading-relaxed text-vec-charcoal/75">
                            Substations are where the grid is switched, transformed and protected.
                            VEC's substation practice spans electrical infrastructure, installation,
                            construction and long-term operation &amp; maintenance of high-voltage
                            facilities.
                        </p>
                    </Reveal>
                    <div className="border border-vec-border">
                        {SCOPES.map((s, i) => (
                            <Reveal key={s} delay={0.12 + i * 0.05}>
                                <div className="group flex items-center justify-between px-5 py-4 border-b last:border-b-0 border-vec-border hover:bg-vec-mist transition-colors duration-300">
                                    <span className="font-display text-sm sm:text-base font-medium text-vec-charcoal group-hover:text-vec-green transition-colors duration-300">
                                        {s}
                                    </span>
                                    <span className="font-mono-tech text-[10px] text-vec-charcoal/40">
                                        S.{String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);
